import { CustomMessage } from "../alert/custom-message";

export function SuccessMessage({ message, closeModal }) {
  return (
    <div>
      <div>
        <CustomMessage messageType="success" />
      </div>
      <div>
        <p className="success-message-text">{message}</p>
      </div>
      <div className="success-message-btn-container p-text-center">
        <p
          onClick={() => {
            const refresh = true;
            closeModal(refresh);
          }}
          className="close-modal add-cursor"
        >
          Close
        </p>
      </div>
    </div>
  );
}
